<template lang="pug">
transition-group.k-actions.k-actions-icons.actions( name='fade' tag='div' )
  template( v-for='( action ) in actions' )
    w-btn-icon(
      v-if='actionPasses( action ) && action.icon && icons[ action.icon ]'
      :key='action.name' 
      @click.prevent='doAction( action )'
    )
      component.icon(
        :is='icons[ action.icon ]'
        :title='action.label' 
      )

</template>

<script lang="js">
import { mapActions, mapGetters } from 'vuex'
import WBtnIcon from '@/widgets/w-btn-icon'
// import WBtnIcon from '@/widgets/w-btn-icon'

export default {
  name: 'IconActionsBlock',
  mixins: [],
  components: { WBtnIcon },
  props: {
    model: Object,
    item: Object,
    items: Array,
    actions: {
      type: Array,
      default: () => []
    },
    icons: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions([ 'openModal' ]),
    async doAction( action ) {
      if ( action.modal ) {
        this.openModal({ name: action.modal.component, data: action.modal.meta })
      } else if ( action.url ) {
        this.$router.push({ path: action.url })
      } else if ( action.dispatch ) {
        if ( this.items ) {
          await this.$store.dispatch( action.dispatch, {
            model: this.model,
            objects: this.items,
          })
        } else {
          await this.$store.dispatch( action.dispatch, {
            model: this.model,
            object: this.item,
          })
        }
        if ( action.refresh ) {
          this.$emit( 'refresh' )
        }
      } else if ( action.fn ) {
        if ( this.items ) {
          this.$emit( 'exec', { fn: action.fn, action, items: this.items })
        } else {
          this.$emit( 'exec', { fn: action.fn, action, item: this.item })
        }
      }
    },
    actionPasses( action ) {
      return !( 'if' in action ) || action.if
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.k-actions {

}
</style>
